import React from "react"

import PropTypes from "prop-types"

import "./index.less"
import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  LabelList,
} from "recharts"
import CustomTooltip from "./components/CustomTooltip"
import { truncateText } from "../../../../utils/functions"

const toPercent = (decimal) => {
  return `${decimal.toFixed(0)}%`
}
/*
const data = [
  {
    name: "Paquete de bienvenida",
    pv: 95,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
]
let dataResult = []
data.map((row) => {
  dataResult.push({
    name: row.name,
    pv: row.pv,
    name_sort: truncateText(row.name, 27),
    value: row.value,
  })
})
*/
export function HorizontalBarMultipleAnswer(props) {
  let dataResult = []
  if (props.data) {
    props.data.map((row) => {
      dataResult.push({
        name: row.answer_option_name,
        pv: Number(row.value),
        name_sort: truncateText(row.answer_option_name, 60),
        value: Number(row.employees),
        value_text: row.value_text,
      })
    })
  }

  let heightChart = dataResult.length * 60
  if (dataResult.length === 5) {
    heightChart = dataResult.length * 68
  }
  if (dataResult.length === 4) {
    heightChart = dataResult.length * 85
  }
  if (dataResult.length === 3) {
    heightChart = dataResult.length * 114
  }
  if (dataResult.length === 2) {
    heightChart = dataResult.length * 171
  }
  const styleChart = { height: `${heightChart}px` }

  return (
    <div className="HorizontalBarMultipleAnswer" style={styleChart}>
      <ResponsiveContainer>
        <BarChart
          layout="vertical"
          data={dataResult}
          margin={{
            top: 5,
            right: 40,
            left: 20,
            bottom: 5,
          }}>
          <CartesianGrid horizontal={false} stroke="#0000000D" />
          <XAxis
            type="number"
            dataKey="pv"
            orientation="top"
            tickLine={false}
            axisLine={false}
            tickMargin={10}
            tickCount={6}
            domain={[0, 100]}
            tick={{ fill: "#8D8A8D", fontSize: "12" }}
            tickFormatter={toPercent}
          />
          <YAxis
            width={200}
            axisLine={{ stroke: "#0000000D" }}
            type="category"
            dataKey="name_sort"
            tickLine={false}
            tickMargin={20}
          />
          <Tooltip
            content={(element) => (
              <CustomTooltip
                element={element}
                measureGeneral={props.measureGeneral}
              />
            )}
            cursor={{ fill: "transparent" }}
          />
          <Bar
            dataKey="pv"
            barSize={28}
            fill="#378FEE"
            radius={[2, 2, 2, 2]}
            isAnimationActive={false}>
            <LabelList
              dataKey="value_text"
              position="right"
              fontSize={12}
              fill="#378FEE"
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

HorizontalBarMultipleAnswer.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  measureGeneral: PropTypes.object,
  getDataChildren: PropTypes.func,
  getBackData: PropTypes.func,
  dimensionParent: PropTypes.number,
  isAmbassador: PropTypes.bool,
  showDimensionBenchmark: PropTypes.bool,
  hideImpact: PropTypes.bool,
}
export default HorizontalBarMultipleAnswer
